import _ from 'lodash';

import { CHANGE_FILTER_VALUE, RESET_FILTER_VALUE } from '../actions';

const initialState = {};

const reducer = (state = initialState, action) => {
  if (!action.payload) {
    return state;
  }

  const { filtersGroupId, filterId, value } = action.payload;

  switch (action.type) {
    case CHANGE_FILTER_VALUE: {
      const newState = _.cloneDeep(state);

      return _.set(newState, [filtersGroupId, filterId], value);
    }

    case RESET_FILTER_VALUE: {
      const newState = _.cloneDeep(state);

      return _.set(
        newState,
        filtersGroupId,
        filterId ? _.omit(newState[filtersGroupId], filterId) : {},
      );
    }

    default:
      return state;
  }
};

export default reducer;
